import React, { useEffect, useState } from 'react';
import '../../App.css';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HomeIcon from '@mui/icons-material/Home';
import GroupIcon from '@mui/icons-material/Group';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';


export default function Dheader() {
  const [showMenu, setShowMenu] = useState(false);
  const [greeting, setGreeting] = useState("");
  const [openLogo, setOpenLogo] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);

 const [profile, setProfile] = useState(null);
 const [editMode, setEditMode] = useState(false);
 const [loaderImage, setLoaderImage] = useState(false);
 const [formData, setFormData] = useState({
    company: "",
    email: "",
    mobileNo: "",
    name: "",
    profilePic: ""
    
  });

  const location = useLocation(); 
  const navigate = useNavigate();

  const [dark, setDark] = useState(() => {
    const stored = localStorage.getItem('selected-theme');
    return stored ? stored === 'dark' : false;
  });

  useEffect(() => {
    document.body.classList.toggle('dark-theme', dark);
    localStorage.setItem('selected-theme', dark ? 'dark' : 'light');
  }, [dark]);

  // shadow header on scroll
  useEffect(() => {
    const handleShadow = () => {
      const header = document.getElementById('header');
      if (!header) return;
      window.scrollY >= 50 ? header.classList.add('shadow-header') : header.classList.remove('shadow-header');
    };
    window.addEventListener('scroll', handleShadow);
    return () => window.removeEventListener('scroll', handleShadow);
  }, []);

  // active-link on scroll (keeps behaviour similar to original)
  useEffect(() => {
    const sections = document.querySelectorAll('section[id]');
    const scrollActive = () => {
      const scrollY = window.scrollY;
      sections.forEach(current => {
        const sectionHeight = current.offsetHeight;
        const sectionTop = current.offsetTop - 58;
        const sectionId = current.getAttribute('id');
        const sectionsClass = document.querySelector('.nav__menu a[href*=' + sectionId + ']');
        if (sectionsClass) {
          if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
            sectionsClass.classList.add('active-link');
          } else {
            sectionsClass.classList.remove('active-link');
          }
        }
      });
    };
    window.addEventListener('scroll', scrollActive);
    return () => window.removeEventListener('scroll', scrollActive);
  }, []);

  // When clicking nav links, close mobile menu
  useEffect(() => {
    const links = document.querySelectorAll('.nav__link');
    const linkAction = () => {
      setShowMenu(false);
    };
    links.forEach(n => n.addEventListener('click', linkAction));
    return () => links.forEach(n => n.removeEventListener('click', linkAction));
  }, []);

  const handleLogout = async () => {
  try {
    await axios.post(
      `${process.env.REACT_APP_FRONTEND_URL}/auth/logout`,
      {},
      { withCredentials: true }
    );

    localStorage.removeItem("isLogin");
    localStorage.removeItem("tregoName");
    localStorage.removeItem("profilePic");

    navigate("/");

  } catch (err) {
    console.log("Logout Error:", err);
  }
};

  // const handleLogout = async()=>{
  //    localStorage.clear();
  //   //  sessionStorage.clear();
  //    navigate('/');
  // }

  const greetingMessage = ()=>{
    const currentHour = new Date().getHours();
    if(currentHour < 12 ){
        setGreeting("Good Monrning 🌞 ");
    } else if(currentHour < 18 ){
        setGreeting("Good Afternoon 🌤️ ");
    } else if(currentHour < 21 ){
        setGreeting("Good Evening 🌇 ");
    }else{
        setGreeting("Good Night 🌙")
    }
  }
  useEffect(()=>{
    greetingMessage();
  }, [])


useEffect(() => {
  const fetchProfile = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_FRONTEND_URL}/auth/profile`,
        { withCredentials: true }
      );
      setProfile(res.data);

    } catch (err) {
      console.log("Fetch Error:", err);
    }
  };

  fetchProfile();
}, []);


  useEffect(() => {
    if (profile) {
      setFormData({
        company: profile.company,
        email: profile.email,
        mobileNo: profile.mobileNo,
        name:profile.userName,
        profilePic: profile.profilePic
      });
    }
  }, [profile]);

const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  
  };

const handleFileChange = async (e) => {
  setLoaderImage(true);
  const files = e.target.files;

  if (!files || files.length === 0) 
    //  setLoaderImage(false);
    return;

  const data = new FormData();
  data.append('file', files[0]);
  data.append('upload_preset', 'trego.in');

  try {
    const response = await axios.post(
      "https://api.cloudinary.com/v1_1/dvawsdzao/image/upload",
      data,
      {
        withCredentials: false
      }
    );

    const imageUrl = response.data.secure_url;

    setFormData((prev) => ({
      ...prev,
      profilePic: imageUrl
    }));
 setLoaderImage(false);
  } catch (err) {
    setLoaderImage(false);
    console.log("Upload Error:", err);
  }
};

const handleUpdate = async () => {
  try {
    const payload = {
      company: formData.company,
      email: formData.email,
      mobileNo: formData.mobileNo,
      name: formData.name,
      profilePic: formData.profilePic // Cloudinary URL
    };

    const res = await axios.put(
      `${process.env.REACT_APP_FRONTEND_URL}/auth/profile/update`,
      payload,
      { withCredentials: true }
    );

    setProfile(res.data.data);
    setEditMode(false);

  } catch (err) {
    console.log("Update Error:", err);
  }
};


  // const handleUpdate = async () => {
  //   try {
  //     const res = await axios.put(
  //       `${process.env.REACT_APP_FRONTEND_URL}/auth/profile/update`,
  //       formData,
  //       { withCredentials: true }
  //     );

  //     setProfile(res.data.data);
  //     setEditMode(false);

  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  return (
    <header className="header" id="header">
      <nav className="nav container">
        <a href="#" className="nav__logo">

      {/* LOGO IMAGE AND NAME  */}
          {/* <span className="nav__logo-circle">
            <img src="../../assets/trakiologoremove.jpeg"alt="logoimage" className="nav__logo-circle" />
          </span>
          <span className="nav__logo-name">Traki. </span> */}
  <div  style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
  onClick={() => setOpenLogo(true)}>
  <span className="nav__logo-circle">
    <img
     src="../../assets/trakiologoremove.jpeg"
      alt="logoimage"
      className="nav__logo-circle"
    />
  </span>

  <span className="nav__logo-name">Traki.</span>
</div>
{openLogo && (
  <div className="modall-overlay"
  onClick={() => setOpenLogo(false)}>
    <div className="modall-box"
    onClick={(e) => e.stopPropagation()}>

      {/* CLOSE BUTTON */}
      <div className='crossIcon'>
      <span
        className="modall-close"
        onClick={() => setOpenLogo(false)}
      >
        ✖
      </span>
      </div>

      {/* IMAGE */}
      <img
        src="../../assets/trakiologoremove.jpeg"
        alt="logo"
        className="modall-image"
      />

      {/* CONTENT SECTION */}
      <div className="modall-content">
     
        <p>
     At Traki, we believe that managing members should be simple, transparent, and dependable. Our platform is designed to streamline membership operations, automate renewals, and provide clear insights into your business. With a commitment to reliability and performance, Traki empowers you to focus on growth while we handle the complexity behind the scenes.
        </p>
      </div>

    </div>
  </div>
)}

          <span className="nav__logo-name"><HandshakeIcon/> </span>

         {/* <div className='Dheader-box'>
                <img className='Dheader-img' alt='gym pic' src={localStorage.getItem("profilePic")}/>
         </div>
          <span className="nav__logo-name">{localStorage.getItem("tregoName")}. </span> */}
<div onClick={() => setOpenProfile(true)} style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
  
  {/* CUSTOMER IMAGE */}
  <div className='Dheader-box'>
    <img
      className='Dheader-img'
      alt='gym pic'
      // src={localStorage.getItem("profilePic")}
      src={profile?.profilePic || "/default.png"}
 />
  </div>

  {/* CUSTOMER NAME */}
  <span className="nav__logo-name">
    {/* {localStorage.getItem("tregoName")} */}
    {profile?.company}
  </span>

</div>
{openProfile && (
  <div
    className="modall-overlay"
    onClick={() => setOpenProfile(false)}
  >
    <div
      className="modall-box profile-modal"
      onClick={(e) => e.stopPropagation()}
    >
      
      {/* CLOSE */}
       <div className='crossIcon'>

      {/* <h2>Company Name : {profile?.company}</h2> */}
        {editMode ? (
               <input
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder="Company name"
              className="addmembers1In"
            />
             ) : (
              //  <h2>Company: {profile?.company}</h2>
               <h2>Business: {profile?.company}</h2>
             )}

      <span
        className="modall-close"
        onClick={() => setOpenProfile(false)}
      >
        ✖
      </span>
      </div>

      {/* TOP IMAGE */}
      <div className="profile-top">
        {/* <img
          // src={localStorage.getItem("profilePic")}
          src={profile?.profilePic || "/default.png"}
          alt="profile"
        />
     */}
     {loaderImage ? (
         <div className="loader"></div>
           ):(
     <img
  src={
    formData.profilePic
      ? formData.profilePic
      : profile?.profilePic || "/default.png"
  }
  alt="profile"
/>
   )}

   {/* <img
  src={
    formData.profilePic
      ? formData.profilePic
      : profile?.profilePic || "/default.png"
  }
  alt="profile"
/> */}
      </div>

      {/* BOTTOM INFO */}
      <div className="profile-info">

                  {/* ✅ EDIT MODE */}
        {editMode ? (
          <>
         
  <input type="file" accept="image/*" onChange={handleFileChange} />
         <br></br>
         <br></br>

            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              // placeholder="name"
              placeholder="userName"
              className="addmembers1In"
            />

            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              className="addmembers1In"
            />

            <input
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleChange}
              placeholder="Mobile"
              className="addmembers1In"
            />
       
        <div className='editsavebtn'>
            <button type="button" onClick={handleUpdate} className="btn blue">Save</button>
    
            <button onClick={() => setEditMode(false)} className="btn blue">Cancel</button>
         </div>
          </>
        ) : (
          <>
            {/* <p>Company: {profile?.company}</p> */}
            <p>userName: {profile?.name}</p>
            <p>Email: {profile?.email}</p>
            <p>Mobile: {profile?.mobileNo}</p>

            <button onClick={() => setEditMode(true)} className="btn blue">
              Edit Profile
            </button>
          </>
        )}

   {/* <p>Your UserName : {profile?.name}</p>
    <p> Mobile Number :{profile?.mobileNo}</p>
   <p> Your Email : {profile?.email}</p> */}

      </div>

    </div>
  </div>
)}

         <span className="nav__logo-name">{greeting}</span>
          {/* <span className="nav__logo-name">{localStorage.getItem("tregoName")} </span> */}

        </a>

        <div className={`nav__menu ${showMenu ? 'show-menu' : ''}`} id="nav-menu">
          <span className="nav__title">Menu</span>

          <h3 className="nav__name">Traki</h3>

          <ul className="nav__list">
            <li className="nav__item">
              <a href="/dashboard" className={`nav__link ${location.pathname==="/dashboard"?"active-link" : ""}` } ><HomeIcon  /> DASHBOARD</a>
            </li>
            <li className="nav__item">
              <Link to={"/member"} className={`nav__link ${location.pathname==="/member"?"active-link" : ""}` }> <GroupIcon /> MEMBERS</Link>
            </li>

            <li className="nav__item ">
              <a onClick={()=>{handleLogout()}} 
               style={{ cursor: "pointer" }}
              // href="/logout" 
              className={`nav__link nav__link-button ${location.pathname==="/logout"?"active-link" : ""}`} ><LogoutIcon />LOGOUT</a>
            </li>
          </ul>

          <div className="nav__close" id="nav-close" onClick={() => setShowMenu(false)}>
            <i className="ri-close-line"></i>
          </div>
        </div>

        <div className="nav__buttons">
          <i
            className={`ri-moon-line change-theme ${dark ? 'ri-sun-line' : ''}`}
            id="theme-button"
            onClick={() => setDark(d => !d)}
            style={{ cursor: 'pointer' }}
            title="Toggle theme"
          ></i>

          <div className="nav__toggle" id="nav-toggle" onClick={() => setShowMenu(s => !s)}>
            <i className="ri-menu-4-line"></i>
          </div>
        </div>
      </nav>
    </header>
  );
}
